import React from "react";
import { useState } from "react";
import {
  validateCNPJ,
  validateCPF,
  validateEmail,
  validatePhone,
} from "../../../../../utils";
import Text from "../../../../../_components/Text";
import { toast } from "react-toastify";
import { validateFields } from "../helpers";

const useChange = (initialState) => {
  const [state, setState] = useState(initialState);

  const handleChange = (e) => {
    let { name, value } = e.target;
    if (["cpf", "cnpj", "phone_number"].includes(name)) {
      value = value.replace(/[^\d]/g, "");
    }
    setState({ ...state, [name]: value });
  };

  // no risk no fun
  handleChange.forceUpdate = (newState) => setState(newState);

  return [state, handleChange];
};

const useGetData = (state) => {
  let data = {};
  if (state.type == 1 || state.type == 3) {
    let fields = [
      { name: "cpf", validator: validateCPF },
      { name: "name", validator: (value) => !!value },
      { name: "phone_number", validator: validatePhone },
      { name: "email", validator: validateEmail },
    ];
    if (state.type == 3) {
      fields.push({ name: "state_registry", validator: (value) => !!value });
    }
    if (!validateFields(state, fields)) {
      return false;
    }
    data = {
      name: state.name,
      email: state.email,
      phone_number: state.phone_number.replace(/\D+/g, ""),
      individual: {
        cpf: state.cpf.replace(/\D+/g, ""),
      },
    };
    if (state.type == 3) {
      if (state.state_registry) {
        data["individual"]["state_registry"] = state.state_registry.replace(
          /\D+/g,
          ""
        );
      }
    }
  } else {
    if (!validateCNPJ(state.cnpj)) {
      toast(<Text align="center">CNPJ inválido.</Text>, {
        toastId: "register-client-cnpj-invalid",
        position: "top-center",
      });
      validateFields(state, [{ name: "cnpj", validator: validateCNPJ }]);
      return false;
    }
    const fields = [
      { name: "cnpj", validator: validateCNPJ },
      { name: "company_name", validator: (value) => !!value },
      { name: "fancy_name", validator: (value) => !!value },
      { name: "company_email", validator: (value) => !!value },
      { name: "company_phone_number", validator: (value) => !!value },
      { name: "company_state_registry", validator: (value) => !!value },
    ];
    if (!validateFields(state, fields)) {
      return false;
    }
    data = {
      name: state.company_name,
      email: state.company_email,
      phone_number: state.company_phone_number.replace(/\D+/g, ""),
      company: {
        cnpj: state.cnpj,
        fancy_name: state.fancy_name,
        state_registry: state.company_state_registry.replace(/\D+/g, ""),
        municipal_registry: "",
      },
    };
  }
  return data;
};

export { useChange, useGetData };



// WEBPACK FOOTER //
// ./src/views/AppViews/Clients/Client/hooks/index.js